import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const OccupancyDetails = ({ hasMortgage, howOccupied, movedInMonth, movedInYear, isPrincipalResidence, hasBusinessActivity, managedBy, hasValidRentalLease, weeklyRentalValue, onClick, getHref }) => {
    const occupancyUrl = 'occupancy';
    const businessActivityUrl = 'business_activity';

    return (
        <SnapshotContainer title="Occupancy">
            {hasMortgage && <SnapshotItem identifier="mortgage" href={getHref(occupancyUrl)} label={`Mortgage - ${hasMortgage}`} onClick={() => onClick(occupancyUrl)} />}
            {isPrincipalResidence === 'Yes' && <SnapshotItem identifier="movedIn" href={getHref(occupancyUrl)} label={`Moved in - ${movedInMonth} ${movedInYear}`} onClick={() => onClick(occupancyUrl)} />}
            <SnapshotItem identifier="howOccupied" href={getHref(occupancyUrl)} label={howOccupied} onClick={() => onClick(occupancyUrl)} />
            {hasBusinessActivity && <SnapshotItem identifier="businessActivity" href={getHref(businessActivityUrl)} label={`Business Activity - ${hasBusinessActivity}`} onClick={() => onClick(businessActivityUrl)} />}
            {managedBy && <SnapshotItem identifier="managedBy" href={getHref(occupancyUrl)} label={`Managed By - ${managedBy}`} onClick={() => onClick(occupancyUrl)} />}
            <SnapshotItem identifier="validLease" href={getHref(occupancyUrl)} label={hasValidRentalLease} onClick={() => onClick(occupancyUrl)} />
            {weeklyRentalValue && <SnapshotItem identifier="rentalIncome" href={getHref(occupancyUrl)} label={`Weekly rental income - ${weeklyRentalValue}`} onClick={() => onClick(occupancyUrl)} />}
        </SnapshotContainer>
    );
};

OccupancyDetails.propTypes = {
    hasMortgage: PropTypes.string,
    howOccupied: PropTypes.string,
    movedInMonth: PropTypes.string,
    movedInYear: PropTypes.string,
    isPrincipalResidence: PropTypes.string,
    hasBusinessActivity: PropTypes.string,
    managedBy: PropTypes.string,
    hasValidRentalLease: PropTypes.string,
    weeklyRentalValue: PropTypes.string,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { OccupancyDetails };
